import { addAlert } from "../configTdm";
import { getProperty } from "../fsConfig";
import * as cookie from 'cookie';
import _ from 'lodash';
import dompurify from 'dompurify';

interface User {
  auth0Id?: string;
  [key: string]: any;
}

export const hasAccountFeature = (feature: string): boolean => {
  const curAccountFeatures = getProperty('session', {}).accountFeatures || [];
  return curAccountFeatures.includes(feature);
}

export const hasOneAndOnlyAccountFeature = (feature: string): boolean => {
  const curAccountFeatures = getProperty('session', {}).accountFeatures || [];
  return _.isEqual(curAccountFeatures, [feature]);
}

export const userServiceMaybeDisplayUpdateEmailMessage = (user: User): void => {
  //const message = dompurify.sanitize(` Please update your email address in the settings page by clicking your username in the top right corner.`);
  const cookieName = 'updateEmailMessageDisplayed';
  const updateEmailMessageDisplayed = cookie.parse(document.cookie)[cookieName];
  const shouldShowMessage = !user.auth0Id && updateEmailMessageDisplayed === undefined;
  if (shouldShowMessage) {
    const thirtyDaysInMilli = 30 * 24 * 60 * 60 * 1000;
    const expires = new Date(Date.now() + thirtyDaysInMilli);
    //addAlert(message, 'info');
    document.cookie = cookie.serialize(cookieName, 'true', { expires, sameSite: 'strict', httpOnly: true, secure: true  });
  }
}

export const hasPermissions = (perms: string | string[]): boolean => {
  const curPermissions = getProperty('session', {}).permissions || [];
  if (!Array.isArray(perms)) {
    perms = [perms];
  }
  return _.intersection(perms, curPermissions).length === perms.length;
}